import Cookies from "js-cookie";
import Bowser from "bowser";
import browserslist from "browserslist";

const Sage = window.Sage;

const OutdatedBrowser = {
  el: null,
  name: "outdated-browser",
  browser: null,

  init: function () {
    this.events();
    this.checkBrowser();
  },

  events: function () {
    $("body").on("click", ".dismiss-ob", function () {
      Cookies.set(OutdatedBrowser.name, true, {
        expires: 365,
      });

      OutdatedBrowser.el.addClass("ob-bar--hidden");
      setTimeout(function () {
        OutdatedBrowser.el.remove();
      }, 250);
    });
  },

  /**
   * Check if browser outdated
   */
  checkBrowser() {
    if (this.isBrowserVersionSupported()) {
      return;
    }

    var cookieSet = Cookies.get(OutdatedBrowser.name);

    if (typeof cookieSet == "undefined") {
      OutdatedBrowser.load();
    }
  },

  isBrowserVersionSupported() {
    // Get browser list from browserslist config
    const browserVersions = browserslist(
      "last 4 versions, not IE 11, not dead, > 1%"
    );

    const browserList = {};

    for (const browser of browserVersions) {
      const [name, version] = browser.split(" ");
      browserList[name] = ">=" + version.split("-")[0];
    }

    // Init Bowser pacakge
    const browser = Bowser.getParser(window.navigator.userAgent);

    // Check if browser is supported
    return browser.satisfies(browserList);
  },

  load: function () {
    $.ajax({
      url: ajaxurl,
      data: {
        action: "outdated_browser",
      },
      type: "POST",
      dataType: "JSON",
    }).then((response) => {
      $(".wrapper").prepend(response);
      OutdatedBrowser.el = $("#ob-bar");

      setTimeout(function () {
        $(OutdatedBrowser.el).removeClass("ob-bar--hidden");
      }, 250);
    });
  },
};
export default OutdatedBrowser;
